import { apiCall } from "api-calls/api-call"

export enum BuffPlayPopupType {
    GIFT_CARD_REDEEM = "GIFT_CARD_REDEEM"
}
export const upsertPopupBuffPlay = async(
  accountId: string,
  type: BuffPlayPopupType,
  text: string,
) => {
  return apiCall({
    method: "PUT",
    path: "buff-play/popups",
    body: { accountId, type, text },
  })
}
